import Client from './client';

export default class OrganizationPaymentSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/payment/settings`, options);
  }

  put(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/payment/settings`, {
      ...options,
       method: 'PUT',
    });
  }

  getVersions(organization, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/payment/settings/versions`, options);
  }

}
